module.exports = __webpack_public_path__ + "img/sire-icon-active.a0de6421.svg";